// extracted by mini-css-extract-plugin
export default {"box":"HamburgerMenu_box__Ra6Gk","menuText":"HamburgerMenu_menuText__tbRn1","text":"HamburgerMenu_text__iXGWl","main":"HamburgerMenu_main__52UJE"};